const adwordsSettings = {
  // nl: {
  //   src: 'https://www.googletagmanager.com/gtag/js?id=AW-11402099175',
  //   config: 'AW-11402099175',
  //   exitMessageConversion: 'AW-11402099175/fSPECKWp8_kBEKP9850D',
  // },
  nl: {
    src: 'https://www.googletagmanager.com/gtag/js?id=AW-868023971',
    config: 'AW-868023971',
    exitMessageConversion: 'AW-868023971/sQWICJjDsL8ZEKP9850D',
  },
  uk: {
    src: 'https://www.googletagmanager.com/gtag/js?id=AW-752131029',
    config: 'AW-752131029',
    exitMessageConversion: 'AW-752131029/f39UCOXV_fYCENW30uYC',
  },
};

if (window.cookies.hasConsent(window.cookies.CONSENT_MARKETING)) {
  loadAdwords();
  // loadAdsense();
} else {
  window.cookies.addEventListener('consent', function ({ detail: { levels } }) {
    if (levels.includes(window.cookies.CONSENT_MARKETING)) {
      loadAdwords();
      // loadAdsense();
    }
  });
}

// Load Adwords script
function loadAdwords() {
  if (window.loadAdwords) {
    const adwordsScript = document.createElement('script');
    adwordsScript.id = 'adwords-script';
    adwordsScript.setAttribute(
      'src',
      adwordsSettings[window.adwordsCountryCode].src
    );
    document.body.appendChild(adwordsScript);
    adwordsScript.addEventListener(
      'load',
      function () {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', adwordsSettings[window.adwordsCountryCode].config);
        if (window.sendExitMessageConversion) {
          gtag('event', 'conversion', {
            send_to:
              adwordsSettings[window.adwordsCountryCode].exitMessageConversion,
          });
        }
      },
      false
    );
  }
}

// Load Adsense script
// function loadAdsense() {
//   const adsensePlaceholder = document.getElementById('adsense-placeholder');
//   if (adsensePlaceholder) {
//     const adsenseScript = document.createElement('script');
//     adsenseScript.setAttribute(
//       'src',
//       'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2332769039455076'
//     );
//     adsenseScript.setAttribute('type', 'text/javascript');
//     adsenseScript.setAttribute('async', '');
//     adsenseScript.setAttribute('crossorigin', 'anonymous');
//     document.head.appendChild(adsenseScript);
//   }
// }
